import { createContext } from 'react';

const LoaderContext = createContext({
  isLoading: false,
  pendingRequests: 0,
  incrementRequests: () => {},
  decrementRequests: () => {},
});

export default LoaderContext;
